import {Component, OnInit, Input, ViewChild} from '@angular/core';
import {AlertaTimerComponent} from './AlertaTimer/AlertaTimer.component';
import {Dialogo} from './Modelo/Dialogo.model';
import {DialogoComponent} from './Dialogo/Dialogo.component';

@Component(
  {
    selector: 'mensaje',
    templateUrl: './Mensaje.template.html',
  })

export class MensajeComponent
{
  @ViewChild('alertaTimer') alertaTimer! : AlertaTimerComponent;
  @ViewChild('dialogo') dialogo! : DialogoComponent;

  constructor()
  {
  }

  ngOnInit()
  {
  }

  CerrarAlertaTimer()
  {
    this.alertaTimer.CancelarAlerta();
  }

  CerrarDialogo()
  {
    this.dialogo.CerrarDialogo(-1);
  }
}
